<template>
  <div style="position: relative">
    <v-layout
      v-if="ductEntryType !== undefined"
      row
      align-center
      justify-center
      class="shape-container"
      :class="{ selected: isSelected }"
      :style="shapeContainerSize"
      @click="toggleForm"
      @contextmenu="$emit('showContextMenu', $event)"
      v-on-clickaway="hideContextMenu"
    >
      <v-flex>
        <duct-entry-shape
          :shape="ductEntryType.shape"
          :width="ductEntryType.width"
          :height="ductEntryType.height"
          :state="ductEntryState"
        >
          <v-layout row align-center justify-center fill-height>
            <v-flex class="font-weight-bold" :style="labelSize">
              {{ ductEntry.mde_label }}
            </v-flex>
          </v-layout>
        </duct-entry-shape>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { ductEntryTypesMixin } from "@/mixins/forms/masks/ductEntryTypesMixin";
import { mixin as clickaway } from "vue-clickaway";
import DuctEntryShape from "./DuctEntryShape";
export default {
  name: "GridDuctEntry",

  components: { DuctEntryShape },

  mixins: [ductEntryTypesMixin, clickaway],

  props: {
    ductEntryIndex: {
      type: Number,
      required: true
    }
  },

  computed: {
    gridUnitSize() {
      return this.$store.getters.getMaskGridUnitSize;
    },

    ductEntry() {
      return this.$store.getters.getDuctEntryByIndex(this.ductEntryIndex);
    },

    ductEntryType() {
      return this.getDuctEntryType(this.ductEntry.mde_entry_type);
    },

    ductEntryState() {
      if (this.ductEntry.mde_total_reservation) {
        return 0;
      } else return parseInt(this.ductEntry.mde_state);
    },

    isSelected() {
      return (
        this.$store.getters.getSelectedDuctEntryIndex === this.ductEntryIndex
      );
    },

    shapeContainerSize() {
      if (this.ductEntryType !== undefined) {
        return {
          width: this.getActualSize(this.ductEntryType.containerWidth),
          height: this.getActualSize(this.ductEntryType.containerHeight)
        };
      }
      return null;
    },

    labelSize() {
      if (this.ductEntryType !== undefined && this.ductEntryType.width < 1) {
        return {
          fontSize: 10 * this.ductEntryType.width + "px"
        };
      } else return null;
    }
  },

  methods: {
    ...mapActions(["setSelectedDuctEntryIndex", "setMasksTabSideSection"]),

    getActualSize(size) {
      return size * this.gridUnitSize + "px";
    },

    toggleForm() {
      let selectedDuctEntryIndex;
      let sideSection;
      if (!this.isSelected) {
        selectedDuctEntryIndex = this.ductEntryIndex;
        sideSection = "ductEntryForm";
      } else {
        selectedDuctEntryIndex = undefined;
        sideSection = "toolbar";
      }
      this.setSelectedDuctEntryIndex(selectedDuctEntryIndex);
      this.setMasksTabSideSection(sideSection);
    },

    hideContextMenu() {
      this.$emit("hideContextMenu");
    }
  }
};
</script>

<style scoped>
.shape-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  background: white;
  border: 1px solid lightgrey;
}

.shape-container.selected {
  background: var(--primary-highlight);
  border: 1px solid var(--primary-highlight);
}

.shape-container:not(.selected):hover {
  background-color: rgba(79, 162, 183, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/GridDuctEntry.vue